var rmUtil = require("../rmlibrary_old/util");
var PDFCanvasNode = require("./canvas");

var extMap = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png"
};

function PDFImageNode(node) {
    var extMatch = node.src.match(/\.(\w+)(\?.*)?(#.*)?$/);
    var ext = (extMatch ? extMatch[1] : "png").toLowerCase();

    this.dataType = extMap[ext] || extMap.jpeg;

    PDFCanvasNode.apply(this, arguments);
}
rmUtil.inherits(PDFImageNode, PDFCanvasNode);

PDFImageNode.prototype.getDataUri = function(dataType) {
    if (this.originalNode.src && this.originalNode.src.indexOf("data:") === 0) {
        return this.originalNode.src;
    }
    var document = this.originalNode.ownerDocument;

    var canvas = document.createElement("canvas");
    canvas.width = this.originalNode.naturalWidth || this.originalNode.width;
    canvas.height = this.originalNode.naturalHeight || this.originalNode.height;

    canvas.getContext("2d").drawImage(this.originalNode, 0, 0);

    var dataUri = canvas.toDataURL(dataType);
    return dataUri;
};

module.exports = PDFImageNode;
